<div class="selection-summary-container">
  <div class="content">
    <div class="summary-content">
      <div class="summary-info">
        <p class="title">SUBTOTAL</p>
        <p class="sub-title">{{ selectedSeats.length }} Tickets</p>
      </div>

      <div class="price-info">
        <p class="price-info-value">RD${{ subTotal.toLocaleString() }}</p>
        <span
          class="material-symbols-outlined expand-btn"
          *ngIf="selectedSeats.length"
          (click)="onExpandToggle()"
          >{{ !expanded ? "arrow_circle_up" : "arrow_circle_down" }}</span
        >
      </div>
    </div>

    <div class="seats-list" *ngIf="expanded">
      <selected-seat-item
        [seat]="seat"
        *ngFor="let seat of selectedSeats"
      ></selected-seat-item>
    </div>
  </div>

  <div class="action">
    <button (click)="goToCheckout.emit()" [disabled]="selectedSeats.length === 0" class="btn-confirm">
      Pasar al checkout
    </button>
  </div>
</div>
